// extracted by mini-css-extract-plugin
module.exports = {"container":"Expandable_container__5asdh","more":"Expandable_more__c_mPA"};